import Box from '../../../../shared/layouts/Box';
import { WithIcon } from '../../../../shared/layouts';
import InfoIcon from 'imagesUwKluis/svg/info.svg';
import AlertSvg from 'imagesUwKluis/svg/alertfill.svg';
import Header from '../../../../shared/Header';
import DescriptionMessage from '../../../../shared/DescriptionMessage';
import TextWithLinks from '../../../../shared/TextWithLinks';
import theme from 'resources/assets/js/theme';
import {useTranslation} from "react-i18next";
import {FC} from "react";

interface CommunicationBarProps {
  isMinDesktop: boolean;
  mainColor: keyof typeof theme.colors;
  isRejected: boolean;
  description: string;
  rejection_reason?: string;
  name: string;
}

const CommunicationBar: FC<CommunicationBarProps> = ({
  isMinDesktop,
  mainColor,
  isRejected,
  description,
  rejection_reason,
  name,
}) => {
  const { t } = useTranslation();
  const descriptionMessage = <TextWithLinks renderAsHtml>{description}</TextWithLinks>;
  const rejectionMessage = rejection_reason && (
    <Box fontWeight="bold" mb="s">
      <TextWithLinks>{rejection_reason}</TextWithLinks>
    </Box>
  );

  return isMinDesktop ? (
    <Box
      flex="320px 0 0"
      p="24px 16px"
      backgroundColor="background"
      borderTop="modal"
      borderTopColor={mainColor}
      height="100%"
      color="primaryFont"
      css={{ overflow: 'auto' }}
    >
      <Box mb="m">
        {isRejected ? (
          <WithIcon color="alert">
            <AlertSvg width="20px" height="20px" />
            <Box fontWeight="bold" lineHeight="20px">
              {t('Afgekeurd document')}
            </Box>
          </WithIcon>
        ) : (
          <WithIcon color="primary">
            <InfoIcon width="20px" height="20px" />
            <Box fontWeight="bold" lineHeight="20px">
              {t('Toelichting')}
            </Box>
          </WithIcon>
        )}
      </Box>
      <Header title={name} variant="page" mt="20px" />
      <Box mt="s">{descriptionMessage}</Box>
      {isRejected && (
        <Box
          mt="m"
          p="m"
          css={({ colors }) => ({ backgroundColor: `${colors.alertHover}28`})}
          fontWeight={'bold'}
          borderRadius={'4px'}
        >
          <Box color={'alert'} fontSize={'m'} mb={'s'}>
            {t('Reden van afkeuring')}
          </Box>
          {rejectionMessage}
        </Box>
      )}
    </Box>
  ) : (
    <Box p="m" pb={'0'}>
      <DescriptionMessage
        title={isRejected ? t('Afgekeurd document') : t('Toelichting')}
        error={isRejected}
      >
        <Box fontWeight="bold">{name}</Box>
        {descriptionMessage}
      </DescriptionMessage>
      {isRejected && (
        <Box
          mt="m"
          p="m"
          css={({ colors }) => ({ backgroundColor: `${colors.alertHover}28`})}
          fontWeight={'bold'}
          borderRadius={'4px'}
        >
          <Box color={'alert'} fontSize={'m'} mb={'s'}>
            {t('Reden van afkeuring')}
          </Box>
          {rejectionMessage}
        </Box>
      )}
    </Box>
  );
};

export default CommunicationBar;
